import RightPanelCard from "components/Common/RightPanelCard";
import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import Select from "react-select";
import { customStyle } from "components/Common/constants";
import DatePicker from "react-datepicker";
import { paymentOptions } from "components/Common/constants";
import { useDispatch, useSelector } from "react-redux";
import { getSparePartList } from "actions/sparePart";
import { getServiceList } from "actions/services";
import { Slider } from "@mui/material";
import {
  quotationDiscountForAll,
  quotationDiscountForSingle,
} from "actions/quotation";
import { useParams } from "react-router-dom";
import { urlDecodedId } from "components/Common/encodeDecodeFunction";
import NotificationAlert from "react-notification-alert";
import { formatSAR } from "components/Common/commonFunctions";
import { getTechniciansList, assignTechnician } from "actions/technicians";
import { quotationRequoteList } from "actions/jobQuotation";
import moment from "moment";
import { markJobUnderWarrenty } from "actions/job";
import { getAvailableDates } from "actions/availableTechnicianDates";
import { formatDateLocal, formatTime } from "components/Common/commonFunctions";
import { WORK_ORDER } from "components/Common/constants";
import { SMALL_CASE_WORK_ORDER } from "components/Common/constants";

// Technician list constant
const TECHNICIAN_OPTIONS = [
  { value: "ALICE_JOHNSON", label: "Alice Johnson" },
  { value: "BOB_SMITH", label: "Bob Smith" },
  { value: "CAROL_WHITE", label: "Carol White" },
  { value: "DAVID_BROWN", label: "David Brown" },
  { value: "EMMAN_DAVIS", label: "Emman Davis" },
  { value: "FRANK_MILLER", label: "Frank Miller" },
  { value: "AHMED_KHAN", label: "Ahmed Khan" },
];

//  Below funtion is used to add technical report
// const initialFields = {
//   serialNo: {
//     value: "",
//     error: "",
//     isChanged: false,
//   },
//   findings: {
//     value: "",
//     error: "",
//     isChanged: false,
//   },
//   causes: {
//     value: "",
//     error: "",
//     isChanged: false,
//   },
//   actions: {
//     value: "",
//     error: "",
//     isChanged: false,
//   },
//   media: {
//     value: [],
//     error: "",
//     isChanged: false,
//   },
// };

const fieldsSendQuotation = {
  to: {
    value: "john.smith@email.com",
    error: "",
    isChanged: false,
  },
  cc: {
    value: "",
    error: "",
    isChanged: false,
  },
  comment: {
    value: "",
    error: "",
    isChanged: false,
  },
};

// export function AddTechnicalReport({ isOpen, handleClose }) {
//   const [reportData, setReportData] = useState(initialFields);

//   const handleChange = (fieldName, newValue) => {
//     setReportData((prev) => ({
//       ...prev,
//       [fieldName]: {
//         ...prev[fieldName],
//         value: newValue,
//         isChanged: false,
//         error: "",
//       },
//     }));
//   };

//   const handleOnClose = () => {
//     handleClose();
//     setReportData(initialFields);
//   };

//   return (
//     <RightPanelCard isOpen={isOpen} onClose={handleOnClose}>
//       <Card className="mb-0">
//         <CardHeader
//           className="d-flex align-items-center justify-content-between"
//           tag="h4"
//         >
//           Add Technical Report
//           <i
//             className="fa fa-close text-muted pointer"
//             onClick={handleOnClose}
//           />
//         </CardHeader>
//         <hr />
//         <CardBody>
//           <Row>
//             <Col md="6" className="mb-3">
//               <FormGroup className="d-flex flex-column align-items-start">
//                 <Label>
//                   Serial Number <span className="text-danger">*</span>
//                 </Label>
//                 <Input
//                   name="serialNo"
//                   type="text"
//                   placeholder="Enter serial number"
//                   value={reportData.serialNo.value}
//                   onChange={(e) => handleChange(e.target.name, e.target.value)}
//                 />
//               </FormGroup>
//             </Col>

//             <Col md="6" className="mb-3">
//               <FormGroup className="d-flex flex-column align-items-start">
//                 <Label>
//                   Other Findings <span className="text-danger">*</span>
//                 </Label>
//                 <Input
//                   name="findings"
//                   type="textarea"
//                   placeholder="Please describe the other finding"
//                   value={reportData.findings.value}
//                   onChange={(e) => handleChange(e.target.name, e.target.value)}
//                 />
//               </FormGroup>
//             </Col>

//             <Col md="6" className="mb-2">
//               <FormGroup className="d-flex flex-column align-items-start">
//                 <Label>Other Causes</Label>
//                 <Input
//                   name="causes"
//                   type="textarea"
//                   placeholder="Please describe the other causes"
//                   value={reportData.causes.value}
//                   onChange={(e) => handleChange(e.target.name, e.target.value)}
//                 />
//               </FormGroup>
//             </Col>

//             <Col md="6" className="mb-3">
//               <FormGroup className="d-flex flex-column align-items-start">
//                 <Label>
//                   Other Actions <span className="text-danger">*</span>
//                 </Label>
//                 <Input
//                   name="actions"
//                   type="textarea"
//                   placeholder="Please describe the other actions"
//                   value={reportData.actions.value}
//                   onChange={(e) => handleChange(e.target.name, e.target.value)}
//                 />
//               </FormGroup>
//             </Col>

//             <Col md="12" className="mb-3">
//               <FormGroup className="d-flex flex-column align-items-start">
//                 <Label>Upload Media</Label>
//                 <div
//                   className="product-image-upload w-100 p-3 border rounded text-center"
//                   onDragOver={(e) => e.preventDefault()} // allow drop
//                   onDragEnter={(e) => e.preventDefault()}
//                   onDrop={(e) => {
//                     e.preventDefault();
//                     const files = Array.from(e.dataTransfer.files).filter(
//                       (file) => file.type.startsWith("image/")
//                     );

//                     if (files.length > 0) {
//                       const file = files[0];
//                       const newImage = {
//                         file,
//                         preview: URL.createObjectURL(file),
//                       };
//                       handleChange("media", [newImage]);
//                     }
//                   }}
//                 >
//                   {reportData.media?.value?.length > 0 ? (
//                     <div className="d-flex flex-wrap justify-content-start">
//                       {reportData.media.value.map((img, index) => (
//                         <div className="image-preview-wrapper mr-2" key={index}>
//                           <img
//                             src={img.preview}
//                             alt={`Product ${index}`}
//                             className="product-preview-img"
//                           />
//                           <span
//                             className="remove-image"
//                             onClick={() => {
//                               const newImages = reportData.media.value.filter(
//                                 (_, i) => i !== index
//                               );
//                               handleChange("media", newImages);
//                             }}
//                           >
//                             &times;
//                           </span>
//                           <p className="file-name mt-2" title={img.name}>
//                             {img.file.name}
//                           </p>
//                         </div>
//                       ))}
//                     </div>
//                   ) : (
//                     <>
//                       <i className="fa fa-cloud-upload fa-2x text-muted mb-2"></i>
//                       <p className="mb-1 text-muted">
//                         Click or drag image to upload
//                       </p>
//                       <Label
//                         for="productImageInput"
//                         className="btn btn-simple btn-sm mt-2"
//                       >
//                         Choose Image
//                       </Label>
//                     </>
//                   )}

//                   <Input
//                     type="file"
//                     name="image"
//                     accept="image/*"
//                     onChange={(e) => {
//                       const file = e.target.files[0];
//                       if (file) {
//                         const newImage = {
//                           file,
//                           preview: URL.createObjectURL(file),
//                         };
//                         handleChange("media", [newImage]); // store as array for consistency
//                         e.target.value = "";
//                       }
//                     }}
//                     className="d-none"
//                     id="productImageInput"
//                   />
//                 </div>
//               </FormGroup>
//             </Col>
//           </Row>
//         </CardBody>

//         <CardFooter className="d-flex justify-content-end mb-0">
//           <Button color="secondary" onClick={handleOnClose} className="mr-2">
//             Cancel
//           </Button>
//           <Button color="default" type="submit" onClick={handleOnClose}>
//             Save
//           </Button>
//         </CardFooter>
//       </Card>
//     </RightPanelCard>
//   );
// }

// Below function is used to change technician
export function ChangeTechnician({
  isOpen,
  handleClose,
  regionId,
  jobID,
  technician,
  onSuccess,
}) {
  const notificationAlertRef = useRef(null);
  const [technicianData, setTechnicianData] = useState({
    technician: { value: "", error: "" },
  });
  const dispatch = useDispatch();
  const technicianListData = useSelector(
    (state) => state.technicians.techniciansList,
  );
  const [technicanDropDownData, settechnicanDropDownData] = useState();
  const [loaderState, setLoaderState] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    if (technician?.value && technicanDropDownData?.length > 0) {
      const selectedTech = technicanDropDownData.find(
        (item) => String(item.value) === String(technician.value),
      );

      if (selectedTech) {
        setTechnicianData((prev) => ({
          ...prev,
          technician: {
            value: selectedTech,
            error: "",
          },
        }));
      }
    }
  }, [technicanDropDownData, technician, isOpen]);

  const notify = (type, message) => {
    //type is either success or danger
    const options = {
      place: "tr", //tr=top-right corner
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5, //notification closes automatically after 5 seconds
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const handleOnClose = () => {
    handleClose();
    setTechnicianData({
      technician: { value: "", error: "" },
    });
  };

  const handleChange = (fieldName, newValue) => {
    setTechnicianData((prev) => ({
      ...prev,
      [fieldName]: {
        ...prev[fieldName],
        value: newValue,
        error: "",
      },
    }));
  };

  const validateFields = () => {
    let valid = true;

    setTechnicianData((prev) => {
      const updated = { ...prev };

      if (!updated.technician.value) {
        updated.technician.error = "Please select technician";
        valid = false;
      }

      return updated;
    });

    return valid;
  };

  const getValidationError = (name, value) => {
    switch (name) {
      case "technician":
        return !value ? "Please select technician" : "";
      default:
        return "";
    }
  };

  const handleOnBlur = (name, value) => {
    const error = getValidationError(name, value);

    setTechnicianData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        error,
      },
    }));
  };

  const handleSave = async () => {
    if (!validateFields()) return;

    try {
      setLoaderState(true);
      const bodyData = {
        technicianID: technicianData.technician.value.value,
      };

      const res = await assignTechnician(jobID, bodyData);

      if (res?.code === 200) {
        notify?.("success", res?.message || "Technician updated successfully");
        onSuccess?.();
        setTimeout(() => {
          handleOnClose();
        }, 500);
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Failed to update technician";

        notify?.("danger", message);
      }
    } catch (error) {
      notify("danger", "Something went wrong!");
    } finally {
      setLoaderState(false);
    }
  };

  const getTechnicianList = () => {
    try {
      let filterJSON = [
        {
          field: "UserStatus",
          condition: "eq",
          filterValues: ["ACTIVE"],
        },
        {
          field: "RegionID",
          condition: "eq",
          filterValues: [String(regionId)],
        },
      ];
      getTechniciansList(dispatch, {
        filters: JSON.stringify(filterJSON),
      });
    } catch (error) { }
  };

  useEffect(() => {
    if (isOpen == true) {
      getTechnicianList();
    }
  }, [isOpen]);

  useEffect(() => {
    if (technicianListData?.data?.technician?.length > 0) {
      let arr = [];
      for (let i = 0; i < technicianListData?.data?.technician?.length; i++) {
        arr.push({
          label: technicianListData?.data?.technician[i]?.fullName,
          value: technicianListData?.data?.technician[i]?.ID,
        });
      }
      settechnicanDropDownData(arr);
    }
  }, [technicianListData]);

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <RightPanelCard isOpen={isOpen} onClose={handleOnClose} isSmall={true}>
        <Card className="mb-0">
          <CardHeader
            className="d-flex align-items-center justify-content-between"
            tag="h4"
          >
            Assign New Technician
            <i
              className="fa fa-close text-muted pointer"
              onClick={handleOnClose}
            />
          </CardHeader>
          <hr />
          <CardBody>
            <Row>
              <Col md="8" className="mb-3">
                <FormGroup
                  className={`has-label ${technicianData.technician.error ? "has-danger" : ""
                    } d-flex flex-column align-items-start`}
                >
                  <Label>
                    Technician <span className="validation-error">*</span>
                  </Label>
                  <Select
                    options={technicanDropDownData}
                    placeholder="Select technician"
                    classNamePrefix="react-select"
                    styles={customStyle}
                    value={technicianData.technician.value || null}
                    onChange={(selected) =>
                      handleChange("technician", selected)
                    }
                    menuPortalTarget={document.body}
                    onBlur={() =>
                      handleOnBlur(
                        "technician",
                        technicianData.technician.value,
                      )
                    }
                    menuPosition={"fixed"}
                  />
                  {technicianData.technician.error && (
                    <small className="validation-error">
                      {technicianData.technician.error}
                    </small>
                  )}
                </FormGroup>
              </Col>
            </Row>
          </CardBody>

          <CardFooter className="d-flex justify-content-end mb-0">
            <Button color="secondary" onClick={handleOnClose} className="mr-2">
              Cancel
            </Button>
            <Button color="default" type="submit" onClick={handleSave}>
              {loaderState ? <i className="fa fa-spinner fa-spin fa-lg text-white" /> : "Save"}
            </Button>
          </CardFooter>
        </Card>
      </RightPanelCard>
    </>
  );
}

// Below function is used to send quotation to customer via email
export function SendQuotation({ isOpen, handleClose }) {
  const [emailData, setEmailData] = useState(fieldsSendQuotation);

  const handleChange = (fieldName, newValue) => {
    setEmailData((prev) => ({
      ...prev,
      [fieldName]: {
        ...prev[fieldName],
        value: newValue,
        isChanged: false,
        error: "",
      },
    }));
  };

  const handleOnClose = () => {
    handleClose();
    setEmailData(fieldsSendQuotation);
  };

  return (
    <RightPanelCard isOpen={isOpen} onClose={handleOnClose}>
      <Card className="mb-0">
        <CardHeader
          className="d-flex align-items-center justify-content-between"
          tag="h4"
        >
          Send Quotation
          <i
            className="fa fa-close text-muted pointer"
            onClick={handleOnClose}
          />
        </CardHeader>
        <hr />
        <CardBody>
          <Row className="mb-4">
            <Col className="user-note px-3 py-2 mx-3 rounded shadow-sm">
              <span className="">
                Please enter valid email addresses. Use commas or spaces to
                separate multiple recipients.
              </span>
            </Col>
          </Row>
          <Row>
            <Col md="6" className="mb-3">
              <FormGroup className="d-flex flex-column align-items-start">
                <Label>
                  To <span className="validation-error">*</span>
                </Label>
                <Input
                  name="to"
                  type="text"
                  placeholder="Enter recipient email addresses"
                  value={emailData.to.value}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
              </FormGroup>
            </Col>

            <Col md="6" className="mb-3">
              <FormGroup className="d-flex flex-column align-items-start">
                <Label>
                  CC <span className="validation-error">*</span>
                </Label>
                <Input
                  name="cc"
                  type="text"
                  placeholder="Enter CC email addresses"
                  value={emailData.cc.value}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
              </FormGroup>
            </Col>

            <Col md="6" className="mb-3">
              <FormGroup className="d-flex flex-column align-items-start">
                <Label>Comment</Label>
                <Input
                  name="comment"
                  type="textarea"
                  placeholder="Enter your comment"
                  value={emailData.comment.value}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
        </CardBody>

        <CardFooter className="d-flex justify-content-end mb-0">
          <Button color="secondary" onClick={handleOnClose} className="mr-2">
            Cancel
          </Button>
          <Button color="default" type="submit" onClick={handleOnClose}>
            Send
          </Button>
        </CardFooter>
      </Card>
    </RightPanelCard>
  );
}

// Below function is used to update job warrenty
export function JobWarranty({ isOpen, handleClose, notify, onSuccess, underWarranty, warrantyNote, }) {
  const [jobData, setJobData] = useState({
    warranty: {
      value: false,
      error: "",
      isChanged: false,
    },
    note: {
      value: "",
      error: "",
      isChanged: false,
    },
  });
  const [isSaveClicked, setIsSaveClicked] = useState(false);

  const { id } = useParams();
  const decodedId = id ? urlDecodedId(id) : null;

  useEffect(() => {
    if (isOpen) {
      setJobData({
        warranty: {
          value: underWarranty === "YES",
          error: "",
          isChanged: false,
        },
        note: {
          value: warrantyNote || "",
          error: "",
          isChanged: false,
        },
      });
    }
  }, [isOpen, underWarranty, warrantyNote]);

  const handleChange = (fieldName, newValue) => {
    setJobData((prev) => ({
      ...prev,
      [fieldName]: {
        ...prev[fieldName],
        value: newValue,
        isChanged: false,
        error: "",
      },
    }));
  };

  const handleOnClose = () => {
    handleClose();
    setJobData({
      warranty: {
        value: false,
        error: "",
        isChanged: false,
      },
      note: {
        value: "",
        error: "",
        isChanged: false,
      },
    });
  };

  const validateFileds = () => {
    let isValid = true;
    const updatedData = { ...jobData };

    if (!updatedData.note.value || updatedData.note.value.trim() === "") {
      updatedData.note.error = "Note is required";
      updatedData.note.isChanged = true;
      isValid = false;
    }

    setJobData(updatedData);

    return isValid;
  };

  const handleSave = async () => {
    const valid = validateFileds();
    if (!valid) {
      return;
    }
    try {
      setIsSaveClicked(true);
      const bodyData = {
        underWarranty: jobData.warranty.value == true ? "YES" : "NO",
        warrantyNote: jobData.note.value,
      };

      const res = await markJobUnderWarrenty(decodedId, bodyData);
      if (res?.code === 200) {
        notify("success", res?.message || `${WORK_ORDER} Warranty Updated Successfully.`);
        onSuccess();
        handleOnClose();
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || `Failed to update ${WORK_ORDER} warranty`;
        notify("danger", message);
      }
    } catch (error) {
      notify("danger", "Something went wrong");
    } finally {
      setIsSaveClicked(false);
    }
  };

  return (
    <RightPanelCard isOpen={isOpen} onClose={handleOnClose} isSmall={true}>
      <Card className="mb-0">
        <CardHeader
          className="d-flex align-items-center justify-content-between"
          tag="h4"
        >
          {`Update ${WORK_ORDER} Warranty`}
          <i
            className="fa fa-close text-muted pointer"
            onClick={handleOnClose}
          />
        </CardHeader>
        <hr />
        <CardBody>
          <Row>
            <Col md="8" className="mb-0 d-flex align-items-center mb-sm-2">
              <FormGroup>
                <Label for="warrantyCheckbox">
                  {WORK_ORDER} Warranty <span className="validation-error">*</span>
                </Label>
                <Input
                  type="checkbox"
                  id="warrantyCheckbox"
                  name="warranty"
                  checked={jobData.warranty.value}
                  onChange={(e) =>
                    handleChange(e.target.name, e.target.checked)
                  }
                  className="custom-checkbox"
                />
              </FormGroup>
            </Col>

            <Col md="9" className="mb-3">
              <FormGroup className="d-flex flex-column align-items-start">
                <Label>
                  Warranty Note <span className="validation-error">*</span>
                </Label>
                <Input
                  name="note"
                  type="textarea"
                  placeholder="Enter warranty note"
                  value={jobData.note.value}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  className={`text-left ${jobData.note.error ? "is-invalid" : ""
                    }`}
                />
                {jobData.note.error && (
                  <small className="validation-error">
                    {jobData.note.error}
                  </small>
                )}
              </FormGroup>
            </Col>
          </Row>
        </CardBody>

        <CardFooter className="d-flex justify-content-end mb-0">
          <Button color="secondary" onClick={handleOnClose} className="mr-2">
            Cancel
          </Button>
          <Button color="default" type="submit" onClick={handleSave}>
            {isSaveClicked ? <i className="fa fa-spinner fa-spin fa-lg text-white" /> : "Save"}
          </Button>
        </CardFooter>
      </Card>
    </RightPanelCard>
  );
}

// Below function is used for continue job action
export function ContinueJob({
  isOpen,
  payloadData,
  regionId,
  technicianID,
  handleClose,
  handleSave,
  jobSchedules,
  isLoading
}) {
  const dispatch = useDispatch();
  const technicianListData = useSelector(
    (state) => state.technicians.techniciansList,
  );
  const getAvailableSlotsData = useSelector(
    (state) => state.availableDates.availableTechnicianDates,
  );

  const [technicanDropDownData, settechnicanDropDownData] = useState();
  const [jobData, setJobData] = useState({
    startDateTime: {
      value: null,
      error: "",
      isChanged: false,
    },
    endDateTime: {
      value: null,
      error: "",
      isChanged: false,
    },
    technician: {
      value: null,
      error: "",
      isChanged: false,
    },
  });

  const previousSchedule = jobSchedules
    ? jobSchedules[jobSchedules?.length - 1]
    : [];

  //to memroized the available dates for particular technician based on id
  const availableDates = useMemo(() => {
    return (getAvailableSlotsData?.data?.days || []).map((d) => {
      const [day, month, year] = d.date.split("-"); //"15-12-2025" -> day = "15", month = "12", year = "2025"
      return formatDateLocal(new Date(year, month - 1, day)); // new Date(2025, 11, 15)
      //convert into yyyy/mm/dd as datepicker need
    });
  }, [getAvailableSlotsData?.data?.days]);

  const availableSlots = useMemo(() => {
    if (!jobData.startDateTime.value) return [];

    const formatted = formatDateLocal(jobData.startDateTime.value);

    const dayData = (getAvailableSlotsData?.data?.days || []).find((d) => {
      const [day, month, year] = d.date.split("-");
      return `${year}-${month}-${day}` === formatted;
    });

    return dayData?.slots || [];
  }, [jobData.startDateTime.value, getAvailableSlotsData]);

  useEffect(() => {
    if (
      isOpen &&
      technicianID &&
      technicianListData?.data?.technician?.length > 0
    ) {
      const selectedTechnician = technicianListData.data.technician.find(
        (tech) => tech.ID === technicianID,
      );

      if (selectedTechnician) {
        setJobData((prev) => ({
          ...prev,
          technician: {
            ...prev.technician,
            value: selectedTechnician,
            error: "",
          },
        }));
      }
    }
  }, [isOpen, technicianID, technicianListData]);

  useEffect(() => {
    const technicianId = jobData.technician.value?.ID;
    if (technicianId) {
      getAvailableDates(dispatch, technicianId);
    }
  }, [jobData.technician.value]);

  const handleChange = (fieldName, newValue) => {
    if (fieldName === "startDateTime") {
      setJobData((prev) => {
        const previousStart = prev.startDateTime.value;

        const isDayChanged =
          !previousStart ||
          previousStart.toDateString() !== newValue.toDateString();

        return {
          ...prev,
          startDateTime: {
            ...prev.startDateTime,
            value: newValue,
            isChanged: true,
            error: "",
          },
          endDateTime: isDayChanged
            ? {
              ...prev.endDateTime,
              value: null,
              isChanged: false,
              error: "",
            }
            : prev.endDateTime,
        };
      });
    } else {
      setJobData((prev) => ({
        ...prev,
        [fieldName]: {
          ...prev[fieldName],
          value: newValue,
          isChanged: true,
          error: "",
        },
      }));
    }
  };

  const getValidationError = (name, value) => {
    switch (name) {
      case "technician":
        return !value ? "Please select a technician" : "";
      case "startDateTime":
        if (!value) {
          return "Please select a start date & time";
        }
        if (jobData.endDateTime.value && value >= jobData.endDateTime.value) {
          return "Start date & time must be before end date & time";
        }
        return "";
      case "endDateTime":
        if (!value) {
          return "Please select a end date & time";
        }
        if (
          jobData.startDateTime.value &&
          value <= jobData.startDateTime.value
        ) {
          return "End date & time must be greater than start date & time";
        }
        return "";
      default:
        return "";
    }
  };

  const validateForm = () => {
    let newScheduledJob = { ...jobData };

    //get all the keys in array
    Object.keys(newScheduledJob).forEach((key) => {
      newScheduledJob[key] = {
        ...newScheduledJob[key],
        error: getValidationError(key, newScheduledJob[key].value),
      };
    });
    setJobData(newScheduledJob); //if error set error state
    return Object.values(newScheduledJob).every((item) => item.error === "");
  };

  const handleOnBlur = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    const error = getValidationError(name, trimmedValue);
    setJobData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: trimmedValue,
        error,
      },
    }));
  };

  const handleOnsave = () => {
    if (!validateForm()) return;
    let Payload = {
      ScheduledFrom: moment(jobData.startDateTime.value)
        .format("YYYY-MM-DD HH:mm:ss"),

      scheduledTo: moment(jobData.endDateTime.value)
        .format("YYYY-MM-DD HH:mm:ss"),

      technicianID: jobData.technician.value?.ID,
    };
    handleSave(Payload);
  };

  const handleOnClose = () => {
    handleClose();
    setJobData({
      startDateTime: {
        value: null,
        error: "",
        isChanged: false,
      },
      endDateTime: {
        value: null,
        error: "",
        isChanged: false,
      },
      technician: {
        value: null,
        error: "",
        isChanged: false,
      },
    });
  };

  const getTechnicianList = () => {
    try {
      let filterJSON = [
        {
          field: "UserStatus",
          condition: "eq",
          filterValues: ["ACTIVE"],
        },
        {
          field: "RegionID",
          condition: "eq",
          filterValues: [String(regionId)],
        },
      ];
      getTechniciansList(dispatch, {
        filters: JSON.stringify(filterJSON),
      });
    } catch (error) { }
  };

  useEffect(() => {
    if (isOpen == true) {
      getTechnicianList();
      setJobData({
        startDateTime: {
          value: null,
          error: "",
          isChanged: false,
        },
        endDateTime: {
          value: null,
          error: "",
          isChanged: false,
        },
        technician: {
          value: null,
          error: "",
          isChanged: false,
        },
      });
    }
  }, [isOpen]);

  useEffect(() => {
    if (technicianListData?.data?.technician?.length > 0) {
      let arr = [];
      for (let i = 0; i < technicianListData?.data?.technician?.length; i++) {
        arr.push({
          label: technicianListData?.data?.technician[i]?.fullName,
          value: technicianListData?.data?.technician[i]?.ID,
        });
      }
      settechnicanDropDownData(arr);
    }
  }, [technicianListData]);

  return (
    <RightPanelCard isOpen={isOpen} onClose={handleOnClose}>
      <Card className="mb-0">
        <CardHeader
          className="d-flex align-items-center justify-content-between"
          tag="h4"
        >
          Continue {WORK_ORDER}
          <i
            className="fa fa-close text-muted pointer"
            onClick={handleOnClose}
          />
        </CardHeader>
        <hr />
        <CardBody>
          <Row className="mb-4">
            <Col className="user-note px-3 py-2 mx-3 rounded shadow-sm">
              <span className="">
                {WORK_ORDER} Scheduled Date & Time :
                <span className="ml-1">
                  {previousSchedule?.scheduledFrom} to{" "}
                  {previousSchedule?.scheduledTo}
                </span>
              </span>
            </Col>
          </Row>
          {availableDates.length === 0 && (
            <div className="mb-4">
              <span className="validation-error">
                No dates available for {jobData?.technician?.value?.fullName}.
                Please set the technician’s availability or select another
                technician.
              </span>
            </div>
          )}
          <Row>
            <Col lg="6" className="mb-4">
              <FormGroup>
                <Label>
                  Start Date & Time <span className="validation-error">*</span>
                </Label>
                {/* Datepicker popup is not visible properly, needs to increase z-index of it. But for demo
                 I have added extra margin at bottom, while actual implementation needs to correct it.*/}
                <DatePicker
                  placeholderText="Select start date & time"
                  selected={jobData.startDateTime.value}
                  onChange={(date) => handleChange("startDateTime", date)}
                  showTimeSelect
                  timeFormat="hh:mm aa"
                  timeIntervals={60}
                  dateFormat="dd MMM yyyy, hh:mm aa"
                  className="form-control cust-datepicker"
                  showIcon
                  toggleCalendarOnIconClick
                  icon={<i className="fa-solid fa-calendar-day fa-md mt-1" />}
                  wrapperClassName="w-100"
                  popperPlacement="bottom-start"
                  popperContainer={({ children }) => (
                    <div className="fixed-popper-container">{children}</div>
                  )}
                  filterDate={(date) =>
                    availableDates.includes(formatDateLocal(date))
                  }
                  filterTime={(time) => {
                    if (!jobData.startDateTime.value) return false;

                    const currentTime = formatTime(time);

                    return availableSlots.some(
                      (slot) =>
                        currentTime >= slot.fromTime &&
                        currentTime < slot.toTime,
                    );
                  }}
                  onBlur={(e) =>
                    handleOnBlur("startDateTime", jobData.startDateTime.value)
                  }
                />
                {jobData.startDateTime.error && (
                  <small className="validation-error">
                    {jobData.startDateTime.error}
                  </small>
                )}
              </FormGroup>
            </Col>

            <Col lg="6" className="mb-4">
              <FormGroup>
                <Label>
                  End Date & Time <span className="validation-error">*</span>
                </Label>
                {/* Datepicker popup is not visible properly, needs to increase z-index of it. But for demo
                 I have added extra margin at bottom, while actual implementation needs to correct it.*/}
                <DatePicker
                  placeholderText="Select end date & time"
                  selected={jobData.endDateTime.value}
                  onChange={(date) => handleChange("endDateTime", date)}
                  showTimeSelect
                  timeFormat="hh:mm aa"
                  timeIntervals={60}
                  dateFormat="dd MMM yyyy, hh:mm aa"
                  className="form-control cust-datepicker"
                  showIcon
                  toggleCalendarOnIconClick
                  icon={<i className="fa-solid fa-calendar-day fa-md mt-1" />}
                  minDate={jobData.startDateTime.value}
                  maxDate={jobData.startDateTime.value}
                  wrapperClassName="w-100"
                  popperPlacement="bottom-start"
                  popperContainer={({ children }) => (
                    <div className="fixed-popper-container">{children}</div>
                  )}
                  // filterDate={(date) =>
                  //   availableDates.includes(formatDateLocal(date))
                  // }
                  filterDate={(date) => {
                    if (!jobData.startDateTime.value) return false;

                    return (
                      formatDateLocal(date) ===
                      formatDateLocal(jobData.startDateTime.value)
                    );
                  }}
                  filterTime={(time) => {
                    if (!jobData.startDateTime.value) return false;

                    const currentTime = formatTime(time);

                    return availableSlots.some(
                      (slot) =>
                        currentTime >= slot.fromTime &&
                        currentTime < slot.toTime,
                    );
                  }}
                  onBlur={(e) =>
                    handleOnBlur("endDateTime", jobData.endDateTime.value)
                  }
                />
                {jobData.endDateTime.error && (
                  <small className="validation-error">
                    {jobData.endDateTime.error}
                  </small>
                )}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col lg="6" className="mb-5">
              {/* <FormGroup className="d-flex flex-column align-items-start">
                <Label>
                  Technician <span className="text-danger">*</span>
                </Label>
                <Select
                  options={technicanDropDownData}
                  placeholder="Select technician"
                  classNamePrefix="react-select"
                  styles={customStyle}
                  value={jobData.technician.value}
                  onChange={(selected) => handleChange("technician", selected)}
                  menuPortalTarget={document.body}
                  menuPosition={"fixed"}
                />
              </FormGroup> */}
              <FormGroup
                className={`has-label ${jobData.technician.error ? "has-danger" : ""
                  } d-flex flex-column align-items-start`}
              >
                {" "}
                <Label>
                  Technician <span className="validation-error">*</span>
                </Label>
                <Select
                  className={`text-left ${jobData.technician.error ? "is-invalid" : ""
                    }`}
                  placeholder="Select a technician"
                  classNamePrefix="react-select"
                  styles={customStyle}
                  options={technicianListData?.data?.technician || []}
                  value={jobData.technician.value}
                  getOptionLabel={(options) => options.fullName}
                  getOptionValue={(options) => options.ID}
                  onChange={(selected) => handleChange("technician", selected)}
                  onBlur={(e) =>
                    handleOnBlur("technician", jobData.technician.value)
                  }
                  menuPortalTarget={document.body}
                  menuPosition={"fixed"}
                />
                {jobData.technician.error && (
                  <small className="validation-error">
                    {jobData.technician.error}
                  </small>
                )}
              </FormGroup>
            </Col>
          </Row>
        </CardBody>

        <CardFooter className="d-flex justify-content-end mb-0 mt-4">
          <Button color="secondary" onClick={handleOnClose} className="mr-2">
            Cancel
          </Button>
          <Button color="default" type="submit" onClick={handleOnsave}>
            {isLoading ? <i className="fa fa-spinner fa-spin fa-lg text-white" /> : "Save"}
          </Button>
        </CardFooter>
      </Card>
    </RightPanelCard>
  );
}

export function RescheduleJob({ isOpen, handleClose, technician }) {
  const [jobData, setJobData] = useState({
    timeSlot: { value: "", error: "", isChanged: false },
    startDateTime: { value: null, error: "", isChanged: false },
    endDateTime: { value: null, error: "", isChanged: false },
    technician: { value: null, error: "", isChanged: false },
    reason: { value: "", error: "", isChanged: false },
  });
  const [availableSlots, setAvailableSlots] = useState([]);

  useEffect(() => {
    if (technician) {
      setJobData((prev) => ({
        ...prev,
        technician:
          TECHNICIAN_OPTIONS.find((option) => option.label === technician) ||
          null,
      }));
    }
  }, []);

  const REASONS = [
    {
      value: "CUSTOMER_REQUESTED_TO_RESCHEDULE",
      label: "Customer requested to reschedule",
    },
    { value: "CUSTOMER_IS_NOT_AVAILABLE", label: "Customer is not available" },
    {
      value: "THE_SITE_IS_CLOSED_OR_NOT_READY",
      label: "The site is closed or not ready",
    },
    {
      value: "THE_EQUIPMENT_IS_NOT_AVAILBLE_ON_THE_SITE",
      label: "The equipment is not availble on the site",
    },
    { value: "THE_LOCATION_WAS_WRONG", label: "The location was wrong" },
    {
      value:
        "THE_TECHNICIAN_IS_STUCK_WITH_ANOTHER_JOB_AND_WILL_TRY_TO_ATTEND_ASAP",
      label:
        "The technician is stuck with another job and will try to attend asap",
    },
    {
      value: "PARTS_ARE_NOT_READY_FOR_COLLECTION",
      label: "Parts are not ready for collection",
    },
    { value: "PERMIT_NOT_READY", label: "Permit not ready" },
    {
      value: "SHIFT_THE_JOB_TO_AN_EARLIER_DATE",
      label: "Shift the job to an earlier date",
    },
  ];

  // sample timesolts that have time only and based on selected new date,
  // date and month is appended to it to make it dynamic for demo purpose
  const timeSolts = [
    { value: "slot1", label: "08:00 AM - 10:00 AM" },
    { value: "slot2", label: "10:00 AM - 12:00 PM" },
    { value: "slot3", label: "12:00 PM - 02:00 PM" },
  ];

  const handleChange = (fieldName, newValue) => {
    setJobData((prev) => ({
      ...prev,
      [fieldName]: {
        ...prev[fieldName],
        value: newValue,
        isChanged: true,
        error: "",
      },
    }));

    // This code dynamically updates the timeslots with the selected date and month.
    // It will be removed later when API is integrated.
    if (fieldName === "startDateTime" && newValue) {
      const date = new Date(newValue);
      const formattedDate = date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
      });

      const updatedSlots = timeSolts.map((slot) => ({
        ...slot,
        label: `${formattedDate} ${slot.label}`,
      }));

      setAvailableSlots(updatedSlots);
    }
  };

  const handleOnClose = () => {
    handleClose();
    setJobData({
      timeSlot: { value: "", error: "", isChanged: false },
      startDateTime: { value: null, error: "", isChanged: false },
      endDateTime: { value: null, error: "", isChanged: false },
      technician: { value: null, error: "", isChanged: false },
      reason: { value: "", error: "", isChanged: false },
    });
  };

  return (
    <RightPanelCard isOpen={isOpen} onClose={handleOnClose}>
      <Card className="location-card mb-0">
        <CardHeader
          className="d-flex align-items-center justify-content-between"
          tag="h4"
        >
          Reschedule {WORK_ORDER}
          <i
            className="fa fa-close text-muted pointer"
            onClick={handleOnClose}
          />
        </CardHeader>
        <hr />

        <CardBody className="scrollbar-inner overflow-auto">
          <Row className="mb-4">
            <Col className="user-note px-3 py-2 mx-3 rounded shadow-sm">
              <span className="">
                {WORK_ORDER} Scheduled Date & Time :
                <span className="ml-1">
                  12 Oct 2025 02:00 PM to 12 Oct 2025 04:00 PM
                </span>
              </span>
            </Col>
          </Row>
          <Row>
            <Col lg="6" className="mb-3">
              <FormGroup className="d-flex flex-column align-items-start">
                <Label>
                  Technician <span className="validation-error">*</span>
                </Label>
                <Select
                  options={TECHNICIAN_OPTIONS}
                  placeholder="Select a technician"
                  classNamePrefix="react-select"
                  styles={customStyle}
                  value={
                    TECHNICIAN_OPTIONS.find(
                      (option) => option.value === jobData.technician.value,
                    ) || null
                  }
                  onChange={(selected) => handleChange("technician", selected)}
                  menuPortalTarget={document.body}
                  menuPosition={"fixed"}
                />
              </FormGroup>
            </Col>

            <Col lg="6" className="mb-3">
              <FormGroup className="d-flex flex-column align-items-start">
                <Label>
                  New Date <span className="validation-error">*</span>
                </Label>
                <DatePicker
                  placeholderText="Select a new date"
                  selected={jobData.startDateTime.value}
                  onChange={(date) => handleChange("startDateTime", date)}
                  dateFormat="dd MMM yyyy"
                  className="form-control cust-datepicker"
                  showIcon
                  toggleCalendarOnIconClick
                  icon={<i className="fa-solid fa-calendar-day fa-md mt-1" />}
                  wrapperClassName="w-100"
                  minDate={new Date()}
                  popperPlacement="bottom-start"
                  popperContainer={({ children }) => (
                    <div className="fixed-popper-container">{children}</div>
                  )}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col lg="6" className="mb-4">
              <Label className="mb-2">
                Available Time Slots <span className="validation-error">*</span>
              </Label>
              <div className="px-3 py-2 time-slot-card rounded border">
                {!jobData.startDateTime.value ? (
                  <span className="no-record-card">
                    Please select a new date to view available time slots.
                  </span>
                ) : availableSlots.length > 0 ? (
                  availableSlots.map((slot, idx) => (
                    <label
                      key={idx}
                      className={`reason-card ${jobData.timeSlot.value === slot.value ? "selected" : ""
                        }`}
                    >
                      <input
                        type="radio"
                        name="timeSlot"
                        value={slot.value}
                        checked={jobData.timeSlot.value === slot.value}
                        onChange={() => handleChange("timeSlot", slot.value)}
                        className="reason-radio"
                      />
                      <span className="reason-text">{slot.label}</span>
                    </label>
                  ))
                ) : (
                  <span className="no-record-card">
                    No available time slots for this date.
                  </span>
                )}
              </div>
            </Col>
            <Col lg="6" className="mb-3">
              <FormGroup className="d-flex flex-column align-items-start w-100">
                <Label className="mb-2">
                  Reason to reschedule this {SMALL_CASE_WORK_ORDER}{" "}
                  <span className="validation-error">*</span>
                </Label>
                <Select
                  options={REASONS}
                  placeholder="Select a reason"
                  classNamePrefix="react-select"
                  styles={customStyle}
                  value={jobData.reason.value}
                  onChange={(selected) => handleChange("reason", selected)}
                  menuPortalTarget={document.body}
                  menuPosition={"fixed"}
                />
              </FormGroup>
            </Col>
          </Row>
        </CardBody>

        <CardFooter className="d-flex justify-content-end mb-0 mt-4">
          <Button color="secondary" onClick={handleOnClose} className="mr-2">
            Cancel
          </Button>
          <Button color="default" type="submit" onClick={handleOnClose}>
            Save
          </Button>
        </CardFooter>
      </Card>
    </RightPanelCard>
  );
}

export const SparePartsSelection = ({
  isOpen,
  handleClose,
  status,
  onSave,
  selectedReasonID,
  selectedParts = [],
  isSaveClicked,
}) => {
  // const requoteReasons = [
  //   { ID: 1, name: "Additional parts are required." },
  //   { ID: 2, name: "Part received is defective or broken." },
  //   { ID: 3, name: "Wrong parts received from the supplier or warehouse." },
  //   { ID: 4, name: "Need to add local parts." },
  //   { ID: 5, name: "Need to remove part which has not been used." },
  //   { ID: 6, name: "Quoted the wrong part." },
  //   { ID: 7, name: "Need to apply discount to quote." },
  // ];

  const dispatch = useDispatch();
  const didInitOrder = useRef(false);
  const sparePartStore = useSelector((state) => state.sparePart.sparePartsList);
  const [search, setSearch] = useState("");
  const [quantities, setQuantities] = useState({});
  const notificationAlertRef = useRef(null);
  const [selected, setSelected] = useState(null);
  const [sparePartListState, setSparePartListState] = useState({
    isLoading: true,
    error: "",
    noRecords: false,
  });

  const [showPartsSelection, setShowPartsSelection] = useState(false);
  const [displaySpareParts, setDisplaySpareParts] = useState([]);
  const [requoteReasons, setRequoteReasons] = useState([]);

  useEffect(() => {
    if (status === "REQUEST_APPROVAL") {
      setShowPartsSelection(false);
      getReasonList();
    } else {
      setShowPartsSelection(true);
    }
  }, [status]);
  const sparePartsData =
    sparePartStore?.data?.sparePart?.map((item) => ({
      ID: item.ID,
      itemNumber: item.itemNumber,
      manufacturer: item.manufacturer?.name || "",
      description: item.description,
      price: item.price,
      quantity: item.quantity,
    })) || [];

  useEffect(() => {
    if (isOpen) {
      setSparePartListState({ isLoading: true, error: "", noRecords: false });
      getSparePartList(
        dispatch,
        null,
        JSON.stringify([
          { field: "Status", condition: "eq", filterValues: ["ACTIVE"] },
        ]),
        search.trim(),
      );

      // getReasonList();
    }
  }, [search, isOpen]);

  const getReasonList = async () => {
    try {
      let filtersJSON = [
        {
          field: "ReasonType",
          condition: "eq",
          filterValues: ["SPARE_PART"],
        },
      ];

      const res = await quotationRequoteList({
        filtersJSON: JSON.stringify(filtersJSON),
      });
      if (res?.code === 200) {
        let array = [];
        let requoteReasons = res?.data.reasons;
        for (let i = 0; i < requoteReasons?.length; i++) {
          array.push({
            ID: requoteReasons[i].ID,
            name: requoteReasons[i].name,
          });
        }
        setRequoteReasons(array);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (!isOpen) return;

    const initialQuantities = {};
    selectedParts.forEach((part) => {
      initialQuantities[part.itemID] = part.quantity;
    });

    setQuantities(initialQuantities);
    didInitOrder.current = false;
  }, [isOpen, selectedParts]);

  useEffect(() => {
    if (!isOpen || didInitOrder.current || !sparePartsData.length) return;

    const selectedSet = new Set(selectedParts.map((part) => part.itemID));

    const ordered = [
      ...sparePartsData.filter((part) => selectedSet.has(part.ID)),
      ...sparePartsData.filter((part) => !selectedSet.has(part.ID)),
    ];

    setDisplaySpareParts(ordered);
    didInitOrder.current = true;
  }, [isOpen, sparePartsData, selectedParts]);

  useEffect(() => {
    if (!isOpen) return;

    if (sparePartStore.code === 200) {
      const list = sparePartStore.data?.sparePart || [];

      setSparePartListState({
        isLoading: false,
        error: "",
        noRecords: list.length === 0,
      });
    } else {
      setSparePartListState({
        isLoading: false,
        error: sparePartStore?.message || "Failed to load spare parts list.",
        noRecords: false,
      });
    }
  }, [sparePartStore, isOpen]);

  const handleSelect = (ID) => {
    setSelected(ID);
    selectedReasonID(ID);
  };

  const handleQuantityChange = (ID, delta) => {
    setQuantities((prev) => ({
      ...prev,
      [ID]: Math.max(0, (prev[ID] || 0) + delta),
    }));
  };

  const totalSelected = Object.values(quantities).reduce(
    (sum, value) => sum + value,
    0,
  );

  const totalCharges = Object.entries(quantities)
    .reduce((acc, [ID, qty]) => {
      const part = sparePartsData.find((p) => p.ID === parseInt(ID));
      return acc + (part ? part.price * qty : 0);
    }, 0)
    .toFixed(2);

  const handleSave = () => {
    const parts = Object.entries(quantities) //{ "1": 2, "3": 0 } → [["1", 2], ["3", 0]]
      // .filter(([_, qty]) => qty > 0) // ["1", 2] → qty = 2 → 2 > 0 → keep
      // ["3", 0] → qty = 0 → 0 > 0 → remove
      .map(([ID, qty]) => ({ ID: Number(ID), quantity: qty })); // ["1", 2] → { ID: 1, quantity: 2 }

    if (onSave) onSave(parts);

    setTimeout(() => {
      handleOnClose();
    }, 1000);
  };

  const notify = (type, message) => {
    let finalMessage = message;

    if (Array.isArray(message)) {
      finalMessage = message[0]?.Msg || "Something went wrong";
    } else if (typeof message === "object") {
      finalMessage = message?.Msg || "Something went wrong";
    }

    const options = {
      place: "tr",
      message: <div>{finalMessage}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    };

    notificationAlertRef?.current?.notificationAlert(options);
  };

  const handleOnClose = () => {
    handleClose();
    setSearch("");
    setQuantities({});
    setSelected(null);
    selectedReasonID(null);
    setShowPartsSelection(false);
  };

  const visibleSpareParts = displaySpareParts.filter(
    (part) =>
      part.itemNumber?.toLowerCase().includes(search.toLowerCase()) ||
      part.manufacturer?.toLowerCase().includes(search.toLowerCase()) ||
      part.description?.toLowerCase().includes(search.toLowerCase()) ||
      part.price.toString().includes(search),
  );

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <RightPanelCard isOpen={isOpen} onClose={handleOnClose}>
        <Card
          // className="spare-parts-wrapper mb-0"
          className={`service-modal spare-parts-wrapper mb-0 ${(status === "REQUEST_APPROVAL") && !showPartsSelection
            ? "card-small"
            : "card-large"
            }`}
        >
          <CardHeader
            className="d-flex align-items-center justify-content-between"
            tag="h4"
          >
            {(status === "REQUEST_APPROVAL")
              ? "Please select the reason for requoting."
              : "Spare Parts"}
            <i
              className="fa fa-close text-muted pointer"
              onClick={handleOnClose}
            />
          </CardHeader>
          <hr />

          <CardBody className="pt-3 pb-0 scrollbar-inner overflow-auto">
            {(status === "REQUEST_APPROVAL") && showPartsSelection === false ? (
              <>
                <div className="service-cards-container">
                  <div>
                    <div className="service-card-grid">
                      {requoteReasons.map((reason) => (
                        <div
                          key={reason.ID}
                          onClick={() => handleSelect(reason.ID)}
                          className={`service-card ${selected === reason.ID ? "selected" : ""
                            }`}
                        >
                          <Row className="services-list px-4">
                            <div className="d-flex align-items-center">
                              <input
                                type="radio"
                                checked={selected === reason.ID}
                                readOnly
                              />
                              <span className="ml-5 text-muted">
                                {reason.name}
                              </span>
                            </div>
                          </Row>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fa fa-search text-muted" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Search by item number, manufacturer, price or quantity"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </InputGroup>

                {sparePartListState.isLoading ? (
                  <div className="loaderContainer text-center py-4">
                    <i className="fa fa-spinner fa-spin fa-2x" />
                  </div>
                ) : sparePartListState.error ? (
                  <div className="text-danger text-center py-4">
                    {sparePartListState.error}
                  </div>
                ) : sparePartListState.noRecords ? (
                  <div className="text-muted text-center py-4">
                    No matching spare parts found.
                  </div>
                ) : (
                  <div className="sp-card-grid">
                    <Row className="d-flex align-items-center justify-content-between p-2 border-bottom text-muted">
                      <Col xs="12" md="5">
                        Items
                      </Col>

                      <Col
                        xs="6"
                        md="2"
                        className="d-flex flex-row flex-md-row justify-content-between align-items-center mt-2 mt-md-0"
                      >
                        Unit Price
                      </Col>

                      <Col
                        xs="6"
                        md="2"
                        className="d-flex flex-row flex-md-row justify-content-between align-items-center mt-2 mt-md-0"
                      >
                        Available&nbsp;Quantity
                      </Col>

                      <Col xs="6" md="3" className="item-quantity">
                        Item Quantity
                      </Col>
                    </Row>
                    {visibleSpareParts.map((part) => (
                      <div key={part.ID} className="sp-card">
                        <Row className="d-flex align-items-center justify-content-between p-0 text-muted">
                          <Col xs="12" md="5">
                            <div className="d-flex flex-column">
                              <span className="part-name">
                                {part.itemNumber}
                              </span>
                              <small className="text-muted part-description">
                                {part.manufacturer}
                              </small>
                              <small className="text-muted part-description">
                                {part.description}
                              </small>
                            </div>
                          </Col>

                          <Col
                            xs="6"
                            md="2"
                            className="d-flex flex-row flex-md-row justify-content-between align-items-center mt-2 mt-md-0"
                          >
                            <span className="text-default part-amount">
                              SAR {formatSAR(part.price)}
                            </span>
                          </Col>

                          <Col
                            xs="6"
                            md="2"
                            className="d-flex flex-row flex-md-row justify-content-end align-items-center mt-2 mt-md-0"
                          >
                            <span className="text-default part-amount">
                              {formatSAR(part.quantity)}
                            </span>
                          </Col>

                          <Col
                            xs="6"
                            md="3"
                            className="d-flex align-items-center justify-content-end"
                          >
                            <div className="sp-qty-wrapper">
                              <button
                                className="sp-btn"
                                onClick={() =>
                                  handleQuantityChange(part.ID, -1)
                                }
                              >
                                −
                              </button>

                              <input
                                type="tel"
                                className="sp-qty-input"
                                value={quantities[part.ID] || 0}
                                min="0"
                                onChange={(e) => {
                                  const val = parseInt(e.target.value, 10);
                                  setQuantities((prev) => ({
                                    ...prev,
                                    [part.ID]: isNaN(val) ? 0 : val,
                                  }));
                                }}
                              />

                              <button
                                className="sp-btn"
                                onClick={() => handleQuantityChange(part.ID, 1)}
                              >
                                +
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </CardBody>

          <CardFooter className="mb-0">
            {showPartsSelection && sparePartsData.length > 0 && (
              <>
                <hr />
                <div className="services-summary">
                  <span>Total Items ({totalSelected})</span>
                  <span>
                    Total Charges:
                    <span className="ml-2 font-weight-bold">
                      SAR {formatSAR(totalCharges)}
                    </span>
                  </span>
                </div>
              </>
            )}
            <div className="d-flex justify-content-end mt-4">
              <Button
                color="secondary"
                onClick={handleOnClose}
                className="mr-2"
              >
                Cancel
              </Button>
              <Button
                color="default"
                type="submit"
                onClick={() => {
                  if ((status === "REQUEST_APPROVAL") && !showPartsSelection) {
                    // Step 1: Reason selection
                    if (!selected) {
                      notify("warning", "Please select a reason.");
                      return;
                    }
                    setShowPartsSelection(true);
                    return;
                  }

                  // Step 2: Save
                  handleSave();
                }}
                disabled={
                  (status === "REQUEST_APPROVAL") &&
                  !showPartsSelection &&
                  !selected // disable Next if no reason
                  // : totalSelected === 0 // disable Save if no parts
                }
              >
                {isSaveClicked ? (
                  <i className="fa fa-spinner fa-spin fa-lg text-white" />
                ) : (
                  (status === "REQUEST_APPROVAL") && !showPartsSelection
                    ? "Next"
                    : "Save"
                )}
              </Button>
            </div>
          </CardFooter>
        </Card>
      </RightPanelCard>
    </>
  );
};

export const ServiceSelection = ({
  isOpen,
  handleClose,
  status,
  onSave,
  selectedReasonID,
  selectedServices = [],
  isSaveClicked,
}) => {
  // const requoteReasons = [
  //   { ID: 1, name: "Quoted high service charges." },
  //   { ID: 2, name: "Quoted low service charges." },
  //   { ID: 3, name: "Need to apply discount on service charges." },
  //   { ID: 4, name: "Selected the wrong service charge." },
  // ];
  const dispatch = useDispatch();
  const didInitOrder = useRef(false);
  const servicesStore = useSelector((state) => state.service.servicesList);
  // const [selected, setSelected] = useState([]);
  const [selectedReason, setSelectedReason] = useState(null);
  const [selectedServicesState, setSelectedServicesState] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterState, setFilterState] = useState({
    searchName: "",
    priceRange: [0, 10000],
  });
  const [serviceListState, setServiceListState] = useState({
    isLoading: true,
    error: "",
    noRecords: false,
  });
  const [displayServices, setDisplayServices] = useState([]);
  const [showServiceSelection, setshowServiceSelection] = useState(false);
  const [requoteReasons, setRequoteReasons] = useState([]);

  const servicesList =
    servicesStore?.data?.Service?.map((item) => ({
      ID: item.ID,
      name: item.title,
      description: item.description,
      price: item.charges,
    })) || [];

  const filteredServices = servicesList.filter(
    (service) =>
      service.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      service.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      service.price.toString().includes(searchTerm),
  );
  useEffect(() => {
    if (status === "REQUEST_APPROVAL") {
      getReasonList();
      setshowServiceSelection(false);
    } else {
      setshowServiceSelection(true);
    }
  }, [status]);

  const getReasonList = async () => {
    try {
      let filtersJSON = [
        {
          field: "ReasonType",
          condition: "eq",
          filterValues: ["SERVICE"],
        },
      ];

      const res = await quotationRequoteList({
        filtersJSON: JSON.stringify(filtersJSON),
      });
      if (res?.code === 200) {
        let array = [];
        let requoteReasons = res?.data.reasons;
        for (let i = 0; i < requoteReasons?.length; i++) {
          array.push({
            ID: requoteReasons[i].ID,
            name: requoteReasons[i].name,
          });
        }
        setRequoteReasons(array);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (!isOpen) return;

    setServiceListState({ isLoading: true, error: "", noRecords: false });

    const filters = buildFilterParams();
    const searchString = filterState.searchName.trim();

    getServiceList(dispatch, null, filters, searchString);
  }, [isOpen, filterState]);

  useEffect(() => {
    if (!isOpen) return;
    const ids = selectedServices.map((service) =>
      typeof service === "object" ? service.itemID : service,
    );

    setSelectedServicesState(ids);
    didInitOrder.current = false;
  }, [isOpen, selectedServices]);

  useEffect(() => {
    if (!isOpen) return;

    if (servicesStore.code === 200) {
      const list = servicesStore.data?.Service || [];

      setServiceListState({
        isLoading: false,
        error: "",
        noRecords: list.length === 0,
      });
    } else {
      setServiceListState({
        isLoading: false,
        error: servicesStore?.message || "Failed to load services list.",
        noRecords: false,
      });
    }
  }, [servicesStore, isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    if (didInitOrder.current) return;
    if (!servicesList.length) return;

    const selectedSet = new Set(
      selectedServices.map((s) => (typeof s === "object" ? s.itemID : s)),
    );
    const ordered = [
      ...servicesList.filter((s) => selectedSet.has(s.ID)),
      ...servicesList.filter((s) => !selectedSet.has(s.ID)),
    ];

    setDisplayServices(ordered);
    didInitOrder.current = true;
  }, [isOpen, servicesList, selectedServices]);

  const buildFilterParams = () => {
    const filters = [
      {
        field: "Status",
        condition: "eq",
        filterValues: ["ACTIVE"],
      },
    ];

    if (
      filterState.priceRange[0] !== 0 ||
      filterState.priceRange[1] !== 10000
    ) {
      filters.push({
        field: "Charges",
        condition: "btw",
        filterValues: [
          String(filterState.priceRange[0]),
          String(filterState.priceRange[1]),
        ],
      });
    }

    return filters.length > 0 ? JSON.stringify(filters) : [];
  };

  // const handleSelect = (ID, ReasonOrServiceID) => {
  //   if (status === "REQUEST_APPROVAL") {
  //     setSelected([ID]);
  //     if (ReasonOrServiceID === "REASON_ID") {
  //       selectedReasonID(ID);
  //     }
  //   } else {
  //     setSelected((prev) =>
  //       prev.includes(ID) ? prev.filter((item) => item !== ID) : [...prev, ID],
  //     );
  //   }
  // };
  const handleSelect = (ID, type) => {
    if (type === "REASON_ID") {
      setSelectedReason(ID);
      selectedReasonID(ID); // keep your callback
    } else {
      setSelectedServicesState((prev) =>
        prev.includes(ID) ? prev.filter((item) => item !== ID) : [...prev, ID],
      );
    }
  };

  const handleSave = () => {
    if (onSave) onSave(selectedServicesState);
    setTimeout(() => {
      handleOnClose();
    }, 1000);
  };

  const handleOnClose = () => {
    setSelectedServicesState([]);
    setSearchTerm("");
    handleClose();
    selectedReasonID(null);
    setSelectedReason(null);
    setshowServiceSelection(false);
  };

  const selectedServiceList = servicesList.filter((s) =>
    selectedServicesState.includes(s.ID),
  );
  const totalCharges = selectedServiceList
    .reduce((sum, s) => sum + s.price, 0)
    .toFixed(2);

  const visibleServices = useMemo(() => {
    return displayServices.filter((service) =>
      service.name.toLowerCase().includes(filterState.searchName.toLowerCase()),
    );
  }, [displayServices, filterState.searchName]);

  return (
    <RightPanelCard isOpen={isOpen} onClose={handleOnClose}>
      <Card
        className={`service-modal mb-0 ${(status === "REQUEST_APPROVAL") && !showServiceSelection
          ? "card-small"
          : "card-large"
          }`}
      >
        <CardHeader
          className="d-flex align-items-center justify-content-between"
          tag="h4"
        >
          {(status === "REQUEST_APPROVAL")
            ? "Please select the reason for requoting."
            : "Services"}

          <i
            className="fa fa-close text-muted pointer"
            onClick={handleOnClose}
          />
        </CardHeader>
        <hr />
        <CardBody className="service-card-body">
          {(status === "REQUEST_APPROVAL") && showServiceSelection == false ? (
            <>
              <div className="service-cards-container">
                {requoteReasons.length > 0 ? (
                  <>
                    <div className="service-card-grid">
                      {requoteReasons.map((reason) => (
                        <div
                          key={reason.ID}
                          onClick={() => handleSelect(reason.ID, "REASON_ID")}
                          className={`service-card ${selectedReason === reason.ID ? "selected" : ""
                            }`}
                        >
                          <Row className="services-list px-4">
                            <div className="d-flex align-items-center">
                              <input
                                type="radio"
                                checked={selectedReason === reason.ID}
                                readOnly
                              />
                              <span className="ml-5 text-muted">
                                {reason.name}
                              </span>
                            </div>
                          </Row>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="text-center text-muted py-4">
                    <div>No reasons found.</div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <Row className="align-items-center mb-3">
                <Col xs="12" md="7">
                  <InputGroup className="input-group mb-3">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText className="d-flex align-items-center">
                        <i className="fa fa-search text-muted" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      className="border-start-0"
                      placeholder="Search by service"
                      value={filterState.searchName}
                      onChange={(e) =>
                        setFilterState((prev) => ({
                          ...prev,
                          searchName: e.target.value,
                        }))
                      }
                    />
                  </InputGroup>
                </Col>

                <Col xs="12" md="5">
                  <div className="mx-2 slider-style mt-2 mb-3">
                    <Row className="align-items-center">
                      <Col xs="6">
                        <Label className="text-muted">Service Charges</Label>
                      </Col>
                      <Col xs="6" className="text-right">
                        <Label className="text-muted">
                          SAR ({filterState.priceRange[0]} -{" "}
                          {filterState.priceRange[1]})
                        </Label>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs="12">
                        <Slider
                          size="small"
                          value={filterState.priceRange}
                          onChange={(e, newValue) =>
                            setFilterState((prev) => ({
                              ...prev,
                              priceRange: newValue,
                            }))
                          }
                          min={0}
                          max={10000}
                          step={100}
                          marks={[
                            { value: 0, label: "0" },
                            { value: 2500, label: "2.5k" },
                            { value: 5000, label: "5k" },
                            { value: 7500, label: "7.5k" },
                            { value: 10000, label: "10k" },
                          ]}
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>

              <div className="service-cards-container">
                {serviceListState.isLoading ? (
                  <div className="loaderContainer text-center py-4">
                    <i className="fa fa-spinner fa-spin fa-2x" />
                  </div>
                ) : serviceListState.error ? (
                  <div className="text-danger text-center py-4">
                    {serviceListState.error}
                  </div>
                ) : serviceListState.noRecords ? (
                  <div className="text-muted text-center py-4">
                    No matching services found.
                  </div>
                ) : (
                  <>
                    <div className="d-flex justify-content-between px-4 py-2 border-bottom text-muted mb-2">
                      <span className="ml-5">Services</span>
                      <span>Charges (SAR)</span>
                    </div>
                    <div className="service-card-grid">
                      {servicesList.map((service) => (
                        <div
                          key={service.ID}
                          onClick={() => handleSelect(service.ID, "SERVICE_ID")}
                          className={`service-card ${selectedServicesState.includes(service.ID)
                            ? "selected"
                            : ""
                            }`}
                        >
                          <Row className="services-list px-4 py-2 align-items-center">
                            <div className="service-left">
                              <input
                                type="checkbox"
                                checked={selectedServicesState.includes(
                                  service.ID,
                                )}
                                readOnly
                                className="service-checkbox"
                              />

                              <div className="service-content">
                                <span className="services-name">
                                  {service.name}
                                </span>
                                {service.description && (
                                  <span className="service-description">
                                    {service.description}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="service-price">
                              SAR {formatSAR(service.price)}
                            </div>
                          </Row>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </>
          )}
        </CardBody>

        <CardFooter className="mb-0">
          {showServiceSelection && filteredServices.length > 0 && (
            <>
              <hr />
              <div className="services-summary">
                <span>Total Services ({selectedServiceList.length})</span>
                <span>
                  Total Charges:
                  <span className="ml-2 font-weight-bold">
                    {totalCharges === 0 ? (
                      "-"
                    ) : (
                      <>SAR {formatSAR(totalCharges)}</>
                    )}
                  </span>
                </span>
              </div>
            </>
          )}

          <div className="d-flex justify-content-end mt-4">
            <Button color="secondary" onClick={handleOnClose} className="mr-2">
              Cancel
            </Button>
            {/* <Button
              color="default"
              type="submit"
              onClick={handleSave}
              disabled={selectedServiceList.length === 0}
            >
              Save
            </Button> */}
            <Button
              color="default"
              type="submit"
              onClick={() => {
                if ((status === "REQUEST_APPROVAL") && !showServiceSelection) {
                  // Step 1: Reason selection
                  if (!selectedReason) {
                    // notify("warning", "Please select a reason.");
                    return;
                  }
                  setshowServiceSelection(true);
                  return;
                }

                // Step 2: Save
                handleSave();
              }}
              disabled={
                (status === "REQUEST_APPROVAL") &&
                !showServiceSelection &&
                !selectedReason
                // : selectedServicesState.length === 0
              }
            >
              {isSaveClicked ? (
                <i className="fa fa-spinner fa-spin fa-lg text-white" />
              ) : ((status === "REQUEST_APPROVAL") && !showServiceSelection
                ? "Next"
                : "Save")}
            </Button>
          </div>
        </CardFooter>
      </Card>
    </RightPanelCard>
  );
};

export const ApplyDiscount = ({
  isOpen,
  handleClose,
  quotationId,
  quotationItems = [],
  onDiscountApplied,
}) => {
  const [activeTab, setActiveTab] = useState("single");
  const [discounts, setDiscounts] = useState({});
  const [discountErrors, setDiscountErrors] = useState({});
  const { id } = useParams();
  const decodedId = id ? urlDecodedId(id) : null;
  const notificationAlertRef = useRef(null);
  const [showLoaderOnClick, setShowLoaderOnClick] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    setActiveTab("single");

    const prefilled = {};
    const discountValues = [];

    quotationItems.forEach((item) => {
      const value = item.discount ?? "";
      prefilled[item.ID] = value;

      if (value !== "" && value !== null && value !== undefined) {
        discountValues.push(Number(value));
      }
    });

    if (discountValues.length > 0) {
      const first = discountValues[0];
      const allSame = discountValues.every((d) => d === first);

      if (allSame) {
        prefilled["all"] = first;
      }
    }

    setDiscounts(prefilled);
  }, [isOpen, quotationItems]);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const getDiscountError = (value) => {
    if (value === "" || value == null) return "";
    const num = Number(value);
    if (isNaN(num)) return "";
    if (num > 100) return "Discount should be less than or equal to 100";
    if (num < 0) return "Discount cannot be negative";
    return "";
  };

  const handleDiscountBlur = (id, value) => {
    const error = getDiscountError(value);

    setDiscountErrors((prev) => ({
      ...prev,
      [id]: error,
    }));
  };

  const handleDiscountChange = (id, value) => {
    if (value === "") {
      setDiscounts((prev) => ({ ...prev, [id]: "" }));
      setDiscountErrors((prev) => ({ ...prev, [id]: "" }));
      return;
    }

    const num = Number(value);
    if (isNaN(num)) return;

    if (num > 100) return;

    setDiscounts((prev) => ({ ...prev, [id]: value }));
    setDiscountErrors((prev) => ({ ...prev, [id]: "" }));
  };

  const notify = (type, message) => {
    let finalMessage = message;

    if (Array.isArray(message)) {
      finalMessage = message[0]?.Msg || "Something went wrong";
    } else if (typeof message === "object") {
      finalMessage = message?.Msg || "Something went wrong";
    }

    const options = {
      place: "tr",
      message: <div>{finalMessage}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    };

    notificationAlertRef?.current?.notificationAlert(options);
  };

  const handleSave = async () => {
    if (!quotationId || !decodedId) {
      notify("warning", `Quotation ID or ${WORK_ORDER} ID is missing`);
      return;
    }

    if (activeTab === "all") {
      const body = {
        quotationID: quotationId,
        discount: Number(discounts["all"]),
      };

      try {
        setShowLoaderOnClick(true);
        const res = await quotationDiscountForAll(body, decodedId);

        if (res?.code !== 200) {
          notify("danger", res?.message || "Failed to apply discount");
          return;
        }

        notify("success", res?.message || "Discount applied successfully");
        await onDiscountApplied?.();

        setTimeout(() => {
          handleOnClose();
        }, 1000);
      } catch (error) {
        notify("danger", "Something went wrong while applying discount");
      } finally {
        setShowLoaderOnClick(false);
      }
    }

    if (activeTab === "single") {
      const items = quotationItems
        .filter((item) => discounts[item.ID])
        .map((item) => ({
          itemID: item.itemID ?? item.ID,
          itemType: item.itemType,
          discount: Number(discounts[item.ID]),
        }));

      if (!items.length) {
        notify("warning", "Please enter discount for at least one item");
        return;
      }

      const body = {
        quotationID: quotationId,
        items,
      };

      try {
        setShowLoaderOnClick(true);
        const res = await quotationDiscountForSingle(body, decodedId);

        if (res?.code !== 200) {
          notify("danger", res?.message || "Failed to apply discount");
          return;
        }

        notify(
          "success",
          res?.message || "Item-wise discount applied successfully",
        );
        await onDiscountApplied?.();

        setTimeout(() => {
          handleOnClose();
        }, 1000);
      } catch (error) {
        notify("danger", "Something went wrong while applying item discount");
      } finally {
        setShowLoaderOnClick(false);
      }
    }
  };

  const handleOnClose = () => {
    setActiveTab("single");
    setDiscounts({});
    handleClose();
  };

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <RightPanelCard isOpen={isOpen} onClose={handleOnClose}>
        <Card className="mb-0 service-modal">
          <CardHeader
            className="d-flex align-items-center justify-content-between"
            tag="h4"
          >
            Apply Discount
            <i
              className="fa fa-close text-muted pointer"
              onClick={handleOnClose}
            />
          </CardHeader>
          <hr />

          <Nav className="custom-small-tabs m-0 p-0">
            <NavItem>
              <NavLink
                className={`text-center ${activeTab === "single" ? "active" : ""
                  }`}
                onClick={() => toggle("single")}
              >
                Discount on Single Item
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`text-center ${activeTab === "all" ? "active" : ""}`}
                onClick={() => toggle("all")}
              >
                Discount on All Items
              </NavLink>
            </NavItem>
          </Nav>

          <CardBody className="scrollbar-inner overflow-auto">
            <TabContent activeTab={activeTab} className="mt-3">
              <TabPane tabId="all">
                <Row>
                  <Col md="8" className="mt-2">
                    <FormGroup className="d-flex flex-column align-items-start">
                      <Label>
                        Discount (%) <span className="validation-error">*</span>
                      </Label>
                      <InputGroup className="input-group">
                        <Input
                          name="discount"
                          type="number"
                          placeholder="Enter discount"
                          value={discounts["all"] || ""}
                          onChange={(e) =>
                            handleDiscountChange("all", e.target.value)
                          }
                          min={0}
                          max={100}
                          maxLength={3}
                        />
                        <InputGroupAddon addonType="append">
                          <InputGroupText className="d-flex align-items-center">
                            %
                          </InputGroupText>
                        </InputGroupAddon>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
              </TabPane>

              <TabPane tabId="single">
                <div className="discount-item-grid">
                  <Row className="d-flex align-items-center justify-content-between p-1 border-bottom text-muted">
                    <Col xs="12" md="6">
                      Items
                    </Col>

                    <Col
                      xs="6"
                      md="3"
                      className="d-flex justify-content-between align-items-center mt-1 mt-md-0"
                    >
                      Unit Price
                    </Col>

                    <Col xs="6" md="3">
                      Discount %
                    </Col>
                  </Row>

                  {quotationItems.map((part) => (
                    <div key={part.ID} className="discount-item-card">
                      <Row className="d-flex align-items-center justify-content-between px-1">
                        <Col xs="12" md="6">
                          <div className="d-flex flex-column">
                            <span className="text-muted small">
                              {part.partCode ||
                                part.serviceCode ||
                                part.itemNumber ||
                                "-"}
                            </span>
                            <span className="font-weight-500">
                              {part.partName ||
                                part.serviceName ||
                                part.description ||
                                "-"}
                            </span>
                          </div>
                        </Col>

                        <Col xs="6" md="3">
                          <span className="text-default">
                            SAR{" "}
                            {part.unitPrice == null
                              ? "-"
                              : formatSAR(part.unitPrice)}
                          </span>
                        </Col>

                        <Col xs="6" md="3">
                          <InputGroup className="input-group mb-0">
                            <Input
                              name="discount"
                              type="number"
                              placeholder="Enter discount"
                              value={discounts[part.ID] || ""}
                              onChange={(e) =>
                                handleDiscountChange(part.ID, e.target.value)
                              }
                              min={0}
                              max={100}
                              maxLength={3}
                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText className="d-flex align-items-center">
                                %
                              </InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </div>
              </TabPane>
            </TabContent>
          </CardBody>
          <CardFooter className="d-flex justify-content-end mb-0 mt-2">
            <Button color="secondary" onClick={handleOnClose} className="mr-2">
              Cancel
            </Button>
            <Button color="default" type="submit" onClick={handleSave}>
              {showLoaderOnClick ? (
                <i className="fa fa-spinner fa-spin fa-lg text-white" />
              ) : (
                "Save"
              )}
            </Button>
          </CardFooter>
        </Card>
      </RightPanelCard>
    </>
  );
};

// currently it's not in used as we are using showAlert for accept quotation action
export const AcceptQuotation = ({ isOpen, handleClose, onAccept, paymentTerm, isLoading }) => {
  const [formData, setFormData] = useState({
    warranty: { value: "", error: "" },
    reason: { value: "", error: "" },
    paymentReceived: { value: "", error: "" },
    paymentTerm: { value: paymentTerm, error: "" },
  });

  const REASONS = [
    { value: "EXTENDED_WARRANTY", label: "Extended Warranty" },
    { value: "INTERNAL_JOB", label: "Internal Job" },
    { value: "OLD_STOCK_ISSUED", label: "Old Stock Issued" },
  ];

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      paymentTerm: { value: paymentTerm, error: "" }
    }))
  }, [isOpen])

  const handleChange = (fieldName, newValue) => {
    // setFormData((prev) => ({
    //   ...prev,
    //   [fieldName]: newValue,
    //   ...(fieldName === "warranty" ? { reason: "" } : {}),
    // }));
    setFormData((prev) => ({
      ...prev,
      [fieldName]: {
        value: newValue,
        error: "", // clear error on change
      },
      ...(fieldName === "warranty" ? { reason: { value: "", error: "" } } : {}),
    }));
  };

  const handleOnClose = () => {
    setFormData({
      warranty: { value: "", error: "" },
      reason: { value: "", error: "" },
      paymentReceived: { value: "", error: "" },
      paymentTerm: { value: 0, error: "" },
    });
    handleClose();
  };

  const sendData = () => {
    if (!validateForm()) return;

    const payload = {
      warranty: formData.warranty.value,
      reason: formData.reason.value,
      paymentReceived: formData.paymentReceived.value,
      paymentTerm: formData.paymentTerm.value,
    };

    onAccept(payload);
  };

  const validateForm = () => {
    let isValid = true;
    const updatedForm = { ...formData };
    if (!formData.paymentReceived.value) {
      updatedForm.paymentReceived.error = "Is payment received is required";
      isValid = false;
    }

    if (!formData.reason.value?.trim()) {
      updatedForm.reason.error = "Note is required";
      isValid = false;
    }

    setFormData(updatedForm);
    return isValid;
  };

  return (
    <RightPanelCard isOpen={isOpen} onClose={handleOnClose} isSmall>
      <Card className="mb-0 service-modal">
        <CardHeader
          className="d-flex align-items-center justify-content-between"
          tag="h4"
        >
          {/* Accept Quotation */}
          Are you sure you want to accept this quotation?
          <i
            className="fa fa-close text-muted pointer"
            onClick={handleOnClose}
          />
        </CardHeader>

        <hr />

        <CardBody>
          {/* <Row>
            <Col lg="12" className="mb-3">
              <FormGroup>
                <Label>
                  Can the warranty be claimed for this job?{" "}
                  <span className="text-danger">*</span>
                </Label>
                <div className="d-flex flex-column mt-1 ml-4">
                  <Label check className="mb-2">
                    <Input
                      type="radio"
                      name="warranty"
                      value="Yes"
                      checked={formData.warranty === "Yes"}
                      onChange={(e) => handleChange("warranty", e.target.value)}
                    />{" "}
                    Yes
                  </Label>

                  <Label check>
                    <Input
                      type="radio"
                      name="warranty"
                      value="No"
                      checked={formData.warranty === "No"}
                      onChange={(e) => handleChange("warranty", e.target.value)}
                    />{" "}
                    No
                  </Label>
                </div>
              </FormGroup>
            </Col>

            {formData.warranty === "No" && (
              <Col lg="12" className="mt-2">
                <FormGroup>
                  <Label>
                    Please select the reason the warranty cannot be claimed.{" "}
                    <span className="text-danger">*</span>
                  </Label>

                  <div className="d-flex flex-column mt-2 ml-4">
                    {REASONS.map((item) => (
                      <Label
                        check
                        key={item.value}
                        className="d-flex align-items-center me-3 mb-2 cursor-pointer"
                      >
                        <Input
                          type="radio"
                          name="reason"
                          value={item.value}
                          checked={formData.reason === item.value}
                          onChange={(e) =>
                            handleChange("reason", e.target.value)
                          }
                          className="me-1"
                        />
                        {item.label}
                      </Label>
                    ))}
                  </div>
                </FormGroup>
              </Col>
            )}
          </Row> */}
          <Row className="mb-4">
            <Col className="user-note px-3 py-2 mx-2 rounded shadow-sm">
              <span className="xs-text">
                Note: Please confirm that payment has been received and the
                appropriate payment term is selected before you proceed, as this
                action cannot be undone.
              </span>
            </Col>
          </Row>
          <Row>
            <Col md="8" className="mb-0 d-flex align-items-center mb-sm-2">
              <FormGroup>
                <Label for="paymentCheckbox">
                  Is Payment Received ?{" "}
                  <span className="validation-error">*</span>
                </Label>
                <span className="radio-wrapper ml-4">
                  <FormGroup check inline>
                    <Label check>
                      <Input
                        type="radio"
                        name="paymentCheckbox"
                        value="YES"
                        checked={formData.paymentReceived.value === "YES"}
                        onChange={() => handleChange("paymentReceived", "YES")}
                      />{" "}
                      Yes
                    </Label>
                  </FormGroup>
                  <FormGroup check inline>
                    <Label check>
                      <Input
                        type="radio"
                        name="paymentCheckbox"
                        value="NO"
                        checked={formData.paymentReceived.value === "NO"}
                        onChange={() => handleChange("paymentReceived", "NO")}
                      />{" "}
                      No
                    </Label>
                  </FormGroup>

                </span>
                <p>
                  {formData.paymentReceived.error && (
                    <small className="validation-error mt-1">
                      {formData.paymentReceived.error}
                    </small>
                  )}</p>
              </FormGroup>
            </Col>

            <Col md="9">
              <FormGroup className="mb-4 d-flex flex-column align-items-start">
                <Label>
                  Select Payment Term{" "}
                  <span className="validation-error">*</span>
                </Label>
                <Select
                  options={paymentOptions}
                  placeholder="Select payment term"
                  classNamePrefix="react-select"
                  styles={customStyle}
                  value={paymentOptions.find(
                    (option) => option.value === formData.paymentTerm.value,
                  )}
                  isDisabled
                  menuPortalTarget={document.body}
                  menuPosition={"fixed"}
                />
              </FormGroup>
            </Col>

            <Col md="9">
              <FormGroup className={`has-label d-flex flex-column align-items-start ${formData.reason.error ? "has-danger" : ""}`}>
                <Label>
                  Enter a Note <span className="validation-error">*</span>
                </Label>
                <Input
                  name="note"
                  type="textarea"
                  placeholder="Enter your comment or note."
                  value={formData?.reason?.value || ""}
                  onChange={(e) => {
                    e.stopPropagation();
                    handleChange("reason", e.target.value);
                  }}
                />
                {formData.reason.error && (
                  <small className="validation-error mt-1">
                    {formData.reason.error}
                  </small>
                )}
              </FormGroup>
            </Col>
          </Row>
        </CardBody>

        <CardFooter className="d-flex justify-content-end mb-0 mt-2">
          <Button color="secondary" onClick={handleOnClose} className="mr-2">
            Cancel
          </Button>
          <Button color="default" type="button" onClick={sendData}>
            {isLoading ? <i className="fa fa-spinner fa-spin fa-lg text-white" />
              : "Yes, Accept"}
          </Button>
        </CardFooter>
      </Card>
    </RightPanelCard>
  );
};
